import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { MessageDto } from "../../../dto/GenApi.iNotPaie.Dto/MessageDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalMessage extends Vue {
	public message: MessageDto = { Id: 0, NumeroMessage: 0, NumeroContrat: 0, Titre: "" };
    public isDisabled = false;
    public dataReady = false;

    public Init(numeroContrat: number, nomSalarie: string, typeMessage: string, idContrat?: number, isDisabled = false): void {
        this.dataReady = false;
    	this.isDisabled = isDisabled;
        ServicesFactoryInstance.ExercicesService.getMessage(typeMessage, numeroContrat, data => {
            if (data == null) {
                this.message = { Id: 0, NumeroMessage: 0, TypeMessage: typeMessage, NumeroContrat: numeroContrat, IdContratFk: idContrat, Titre: ((typeMessage == "E" ? "MESSAGE BULLETIN - " : "MESSAGE D'INFORMATION - ") + nomSalarie + " -").substring(0, 40) };
            } else {
                this.message = data;
            }
            if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
                this.message.IdSocieteFk = ParametresInstance.societeCourante.Id;
            }

            this.dataReady = true;
        }, _ => {
            this.dataReady = true;
        });
	}

	public annuler(): void {
    	$("#modalMessage").modal("hide");
	}

	public envoyer(): void {
    	if (this.message.Id === 0) {
    		if (this.message.Message1 === undefined || this.message.Message1 === "") {
    			NotificationServiceInstance.SendWarning("Veuillez renseigner un message.");

    			return;
    		}

    		ServicesFactoryInstance.ExercicesService.ajoutMessage(this.message, () => {
    			NotificationServiceInstance.SendSuccess("Le message a bien été créé.");
				this.$emit("messageAdded", {
					NumeroContrat: this.message.NumeroContrat,
					IdContratFk: this.message.IdContratFk,
					TypeMessage: this.message.TypeMessage
				});
    		});
    	} else {
    		if (this.message.Message1 === "") {
    			ServicesFactoryInstance.ExercicesService.deleteMessage(this.message.Id, () => {
    				NotificationServiceInstance.SendSuccess("Le message a bien été supprimé.");
					this.$emit("messageDeleted", {
						NumeroContrat: this.message.NumeroContrat,
						IdContratFk: this.message.IdContratFk,
						TypeMessage: this.message.TypeMessage
					});
    			});
    		} else {
    			ServicesFactoryInstance.ExercicesService.updateMessage(this.message, () => {
    				NotificationServiceInstance.SendSuccess("Le message a bien été mis à jours.");
    			});
    		}
    	}

    	this.annuler();
	}
}



// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/modalMessage/modalMessage.ts